<template>
  <div>
    <div class="spaced-row -heading">
      <h1 class="flex-spacer">Voucher overview</h1>
      <period-selector @changes="handleChange" />
    </div>

    <div v-if="loaded">
      <div>
        <voucher-chart :coupons="coupons" :period="period" :width="1000" :height="500" />
      </div>
      <div>
        <voucher-overview :form="form" />
      </div>
    </div>
    <h2 v-else>Loading data...</h2>
  </div>
</template>

<script>
import VoucherChart from '../charts/VoucherChart.vue'
import PeriodSelector from './PeriodSelector.vue'
import VoucherOverview from './VoucherOverview.vue'

export default {
  components: {
    VoucherChart,
    PeriodSelector,
    VoucherOverview,
  },

  props: {
    id: { type: String, default: null },
    form: { type: Object, default: null },
  },

  data: () => ({
    coupons: null,
    period: null,
    loaded: false,
  }),

  watch: {
    period: {
      deep: true,
      handler() {
        this.fetchData()
      },
    },
    id(to, from) {
      // fetch new data if route changes
      this.fetchData()
    },
  },

  created() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      if (this.period === null) return

      this.loaded = false

      const coupons = await this.$store.dispatch('getCoupons', {
        locationId: this.id,
        startDate: this.period.start,
        endDate: this.period.end,
      })
      // Await for the canvas to be ready ("Cannot read property getContext() of undefined")
      this.loaded = true
      this.coupons = coupons
    },

    handleChange(period) {
      this.period = period
    },
  },
}
</script>

<style scoped>
.-heading {
  margin-bottom: 20px;
}
</style>
